import React from 'react';
import PrivateRoute from './private-route.js';
import Roles from './roles.js'
import Users from './users.js'
import ProjectsAdmin from './projects-admin.js'
import {Nav, NavItem} from 'react-bootstrap';
import {LinkContainer} from 'react-router-bootstrap';

export default (match) => (
    <div>
        <Nav bsStyle="tabs">
            <LinkContainer exact to="/admin">
                <NavItem>Users</NavItem>
            </LinkContainer>
            <LinkContainer to="/admin/projects">
                <NavItem>Projects</NavItem>
            </LinkContainer>
            <LinkContainer to="/admin/roles">
                <NavItem>Roles</NavItem>
            </LinkContainer>
        </Nav>

        <PrivateRoute exact path="/admin" component={Users}/>
        <PrivateRoute exact path="/admin/roles" component={Roles}/>
        <PrivateRoute exact path="/admin/projects" component={ProjectsAdmin}/>
    </div>
);


// WEBPACK FOOTER //
// ./src/admin.js